import { MODAL_VISIBILITY } from './constants';
import { AnyAction } from 'redux';

export function toggleModalVisibility(visible: boolean): AnyAction {
  return { type: MODAL_VISIBILITY };
}
